<aside class="sidebar">
  <!-- Brand -->
  <div class="sidebar-brand">
    <img src="images/clm4sp-brand.png" alt="CLM4SP" class="brand-logo" />
  </div>

  <!-- Navigation -->
  <nav class="sidebar-nav" role="navigation" aria-label="Main navigation">
    @for (item of menu(); track item.label) {
      <div class="nav-item">
        @if (item.children) {
          <!-- Parent with children: toggle only -->
          <div class="nav-parent" (click)="toggle(item)" role="button"
               [attr.aria-expanded]="item.expanded"
               tabindex="0" (keydown.enter)="toggle(item)">
            <i class="bi {{ item.icon }} nav-icon"></i>
            <span class="nav-label">{{ item.label }}</span>
            <i class="bi bi-chevron-right nav-chevron"
               [class.rotated]="item.expanded"></i>
          </div>

          <!-- Children -->
          @if (item.expanded) {
            <div class="nav-children">
              @for (child of item.children; track child.route) {
                <a class="nav-child"
                   [routerLink]="child.route"
                   routerLinkActive="active"
                   (click)="$event.stopPropagation()">
                  {{ child.label }}
                </a>
              }
            </div>
          }
        } @else {
          <!-- Leaf item: navigate directly -->
          <a class="nav-parent"
             [routerLink]="item.route"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{ exact: true }">
            <i class="bi {{ item.icon }} nav-icon"></i>
            <span class="nav-label">{{ item.label }}</span>
          </a>
        }
      </div>
    }
  </nav>

  <!-- Footer: Logout -->
  <div class="sidebar-footer">
    <div class="nav-logout" role="button" tabindex="0" aria-label="Logout"
         (click)="logout()" (keydown.enter)="logout()">
      <i class="bi bi-box-arrow-right nav-icon"></i>
      <span>Logout</span>
    </div>
  </div>
</aside>
